export const handleModalZIndexOnFullscreen = (editorRef: React.RefObject<HTMLDivElement>) => {
  if (!editorRef.current) return;
  
  const classes = editorRef.current.classList;
  const isEnteringFullscreen = classes.contains('fullscreen');
  const modalRoot = document.getElementById('modalroot');
  const modalSidebar = document.querySelector('.entry-in-modal-sidebar--topmost');
  const reactListHocContainer = modalSidebar?.querySelector('.react-list-hoc-container');
  const rteRoot = document.getElementById('root');
  
  if (modalRoot) {
    if (isEnteringFullscreen) {
      // Entering fullscreen mode
      // modalRoot.style.zIndex = '15';
      if (reactListHocContainer) {
        reactListHocContainer.classList.add('fullscreen');
      }
    } else {
      // Exiting fullscreen mode
      // modalRoot.style.zIndex = '';
      if (reactListHocContainer) {
        reactListHocContainer.classList.remove('fullscreen');
      }
    }
  }

  if(rteRoot) {
    if (isEnteringFullscreen) {
      rteRoot.classList.add('jsonrte-plugins-fullscreen')
    } else {
      rteRoot.classList.remove('jsonrte-plugins-fullscreen');
    }
  }
};